// extracted by mini-css-extract-plugin
export default {"StyledReceipt":"payForOther_StyledReceipt__RTDTY"};